<div class="block {{disable ? 'disable' : ''}}">
	<div class="cell" *ngFor="let item of designVal">
		{{item}}
	</div>
</div>
<textarea *ngIf="!disable" class="{{editing ? 'editing' : ''}}" type="text" detectionDesignVal (focus)="editing = true"
	[(ngModel)]="val" (blur)="onValChange()">
</textarea>